import React from "react";
// import { Link } from "react-router-dom";




export default class Events extends React.Component {

    render(){
        return(
            <div>
                <div class="wrapper">
                    <section class="bread-crumb-container">
                        <div class="bread-crumb-img">
                            <img src="/assets/images/bread-crumb3.png" alt=""/>
                        </div>
                        <div class="bread-crumb-content">
                            <div class="bread-crumb-inner">
                                <h2>events</h2>
                                <a href="index.html">Home</a> - <a href="event.html">Events</a>
                            </div>
                        </div> {/* <!-- bread-crumb-content --> */}
                    </section> {/* <!-- bread-crumb-container --> */}
                    <div class="main-part">

                        <section class="our-client-container">
                            <div class="container"> 
                                <div class="heading wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <div class="row">
                                        <div class="text-center col-sm-12">
                                            <h2>Bring Village Style Food to Your Celebrations</h2>
                                        </div>
                                    </div> 
                                </div> {/* <!-- heading --> */}
                                <div class="our-client text-left">
                                    <div class="col-md-12 col-sm-12 col-xs-12">
                                        <div class="client-content wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                            <p style={{fontSize:18}}><span class="quort">“</span>Looking for  <span style={{fontWeight:'700'}}>authentic South Indian catering in Hyderabad</span>? At Village Cafe, we cater to all occasions - starting from <span style={{fontWeight:'700'}}>10 members</span>.</p>
                                        </div> {/* <!-- client-content --> */} 
                                    </div>
                                </div>
                                <div class="our-client text-left">
                                    <h3 style={{marginLeft:20}}>Our Catering Services : </h3>
                                </div>
                                    
                            </div>
                        </section>

                        
                        

                     <section class="event-container" style={{marginTop:50}}>
                        <div class="container">
                        <div class="news-detail">
                            <div class="row">
                            <div class="col-md-12 col-sm-12 col-xs-12">
                                <div class="event-detail-wrap">
                                    <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <div class="event-pic" style={{alignItems:'center',justifyContent:'center'}}>
                                            <img src="/assets/images/news1.jpg" alt="" />
                                        </div>
                                        <div style={{marginTop:40,marginBottom:100}}>
                                            <h3 style={{paddingTop:40}}>Corporate catering</h3>
                                            <p>for meetings & events</p>
                                        </div>
                                    </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}

                                <div class="event-detail-wrap">
                                    <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <div class="event-pic" style={{alignItems:'center',justifyContent:'center'}}>
                                            <img src="/assets/images/news1.jpg" alt="" />
                                        </div>
                                        <div style={{marginTop:40,marginBottom:100}}>
                                            <h3 style={{paddingTop:40}}>Family gatherings & small functions</h3>
                                            <p>&emsp;</p>
                                        </div>
                                    </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}

                                <div class="event-detail-wrap">
                                    <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <div class="event-pic" style={{alignItems:'center',justifyContent:'center'}}>
                                            <img src="/assets/images/news1.jpg" alt="" />
                                        </div>
                                        <div style={{marginTop:40,marginBottom:100}}>
                                            <h3 style={{paddingTop:40}}>Weddings & birthday parties</h3>
                                            <p>&emsp;</p>
                                        </div>
                                    </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}

                                <div class="event-detail-wrap">
                                    <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <div class="event-pic" style={{alignItems:'center',justifyContent:'center'}}>
                                            <img src="/assets/images/news1.jpg" alt="" />
                                        </div>
                                        <div style={{marginTop:40,marginBottom:100}}>
                                            <h3 style={{paddingTop:40}}>Village style thali catering</h3>
                                            <p>with healthy options</p>
                                        </div>
                                    </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}
                     
                               

                                {/* <div class="event-detail-wrap event-detail-noimg">
                                    <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms"> 
                                        <p>Each food truck serves our signature dishes - from <span style={{fontWeight:'700'}}>ragi dosa </span>and <span style={{fontWeight:'700'}}>jowar roti </span>to <span style={{fontWeight:'700'}}>village-style thalis</span>.</p>
                                    </div> {/* <!-- event-list --> */}
                                {/* </div> <!-- event-wrap --> */} 
                                
                                {/* <div class="news-pagination">
                                <ul>
                                    <li class="active"><a href="#/">1</a></li>
                                    <li><a href="#/">2</a></li>
                                    <li><a href="#/">3</a></li>
                                    <li><a href="#/"><i class="fa fa-chevron-right" aria-hidden="true"></i></a></li>
                                </ul>
                                </div> <!-- news-pagination --> */}
                            </div>
                            
                            </div>
                            </div> {/* <!-- post-detail --> */}
                            <div style={{margin:5}}> 
                                {/* <span style={{fontSize:20,fontWeight:'700'}}>Each order is prepared with </span> */}
                                <p style={{fontSize:20}}>Each order is prepared with <span style={{fontWeight:'700'}}>grandma's touch</span>, ensuring every guest enjoys the warmth of <span style={{fontWeight:'700'}}>traditional home food</span>.</p>
                            </div>
                        </div>
                        
                    </section> {/* <!-- event-container --> */}
                    <div class="map-outer">
                        <div id="truck-locator"></div>
                    </div>
                    </div> {/* <!-- main-part --> */}
                </div>
            </div>
        )
    }
}